import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { SgoModuloService } from 'src/app/modules/projeto-completo/services/sgo-modulo.service';


@Injectable({
  providedIn: 'root'
})
export class SgoModuloListResolver implements Resolve<boolean> {

  constructor(private service: SgoModuloService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}